import loadable from '@loadable/component';

export const NewbuildingMapModalContainerLoadable = loadable(() => import('./NewbuildingMapModalContainer'));
